import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Logo from "../Logo";

const links = [
  { id: "nosotros", label: "Nosotros" },
  { id: "servicios", label: "Servicios" },
  { id: "experiencia", label: "Experiencia" },
  { id: "equipo", label: "Equipo" },
  { id: "clientes", label: "Clientes" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-300 ${
        scrolled ? "bg-jauja-bg/80 backdrop-blur-xl border-b border-white/10 py-2.5" : "bg-transparent py-3.5"
      }`}
      data-testid="landing-nav"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="text-2xl" data-testid="nav-logo-btn">
          <Logo height={52} />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-sm text-white/70 hover:text-jauja-lime transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => go("contacto")}
            data-testid="nav-contact-cta"
            className="hidden sm:inline-flex items-center rounded-full bg-jauja-lime px-5 py-2.5 text-sm font-bold text-jauja-bg transition-transform duration-200 hover:scale-105"
          >
            Contáctanos
          </button>
          <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden mt-3 mx-4 rounded-2xl border border-white/10 bg-jauja-surface p-4 flex flex-col gap-1">
          {links.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} className="text-left px-3 py-3 text-white/80 hover:text-jauja-lime" data-testid={`nav-mobile-link-${l.id}`}>
              {l.label}
            </button>
          ))}
          <button onClick={() => go("contacto")} className="mt-2 rounded-full bg-jauja-lime px-5 py-3 text-sm font-bold text-jauja-bg">
            Contáctanos
          </button>
        </div>
      )}
    </header>
  );
}
